import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';



import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoDescPesquisa,
  CampoFormCadastro,
  FormPesquisa,
  DescCampo,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  CampoFormBusca,
  ClienteProdutoSelecionado,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  BtCheckBox,
  EndLinha01,
  EndLinha02,
  EndLinha03,
  EndLinha04,
  DivFilePesquisa
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFormularioAtendimentoTecnico(props) {

  const history = useHistory();
  const location = useLocation();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor")
    }
  }, []);

  var idRequisicao = location.state.idRequisicao;

  const [ TextoAguarde, setTextoAguarde ] = useState(false);

  function ValidaData(input){
    var VerificaData = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true
    } else {
      return false
    }
  }
  function ValidaHora(input){
    var VerificaData = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true
    } else {
      return false
    }
  }

  const EnviarFormulario = async (data, e) => {  

      if(data.c_datain == null || data.c_datain == ''){
        AlertForm('Você precisa adicionar a data do check-in');
        e.preventDefault();
        return false
      }

      if(!ValidaData(data.c_datain)){
        AlertForm('Verifique a data do check-in');
        e.preventDefault();
        return false
      }

      if(data.c_horain == null || data.c_horain == ''){
        AlertForm('Você precisa adicionar a hora do check-in');
        e.preventDefault();
        return false
      }

      if(data.c_comofoi == null || data.c_comofoi == ''){
        AlertForm('Você precisa informar como foi o atendimento');
        e.preventDefault();
        return false
      }

      if(data.c_qnt == null || data.c_qnt == ''){
        AlertForm('Você precisa informar quantas pessoas foram treinadas');
        e.preventDefault();
        return false
      }

      if(data.c_dataout == null || data.c_dataout == ''){
        AlertForm('Você precisa adicionar a data do check-out');
        e.preventDefault();
        return false
      }

      if(!ValidaData(data.c_dataout)){
        AlertForm('Verifique a data do check-out');
        e.preventDefault();
        return false
      }

      if(data.c_horaout == null || data.c_horaout == ''){
        AlertForm('Você precisa adicionar a hora do check-out');
        e.preventDefault();
        return false
      }

      console.log('data', data);



      setTextoAguarde(true);

      // var Preco = PrecoPao
      // .replace("R$ ","")
      // .replace(".","")
      // .replace(",",".");



      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);
      var formdata = new FormData();

      var diaIn = data.c_datain.substr(0, 2);
      var mesIn = data.c_datain.substr(3, 2);
      var anoIn = data.c_datain.substr(6, 4);
      var horIn = data.c_horain.substr(0, 2);
      var minIn = data.c_horain.substr(3, 2);
  
      var diaOut = data.c_dataout.substr(0, 2);
      var mesOut = data.c_dataout.substr(3, 2);
      var anoOut = data.c_dataout.substr(6, 4);
      var horOut = data.c_horaout.substr(0, 2);
      var minOut = data.c_horaout.substr(3, 2);

      
      if(data.c_bonificacao === 0) {
        var CBonificacao = false;
      } else {
        var CBonificacao = true;            
      }

      await formdata.append("requisicaoId", idRequisicao);
      await formdata.append("checkIn", anoIn+"-"+mesIn+"-"+diaIn+"T"+horIn+":"+minIn+":04.080Z");
      await formdata.append("checkOut", anoOut+"-"+mesOut+"-"+diaOut+"T"+horOut+":"+minOut+":04.080Z");
      await formdata.append("observacao", data.c_comofoi);
      await formdata.append("pessoasTreinadas", data.c_qnt);
      if(ProdNome !== "") { await formdata.append( "foto", ProdNome, ProdNome.name ); } else { await formdata.append( "foto", "" ); }
      if(NFNome !== "") { await formdata.append( "arquivo", NFNome, NFNome.name ); } else { await formdata.append( "arquivo", "" ); }
      await formdata.append("bonificacao", CBonificacao);
      await formdata.append("gastosInsumo", c_gastos_insumo == 'R$ 0.00' ? 0.00 : c_gastos_insumo);
      await formdata.append("gastosProdutosInternos", c_gastos_produto == 'R$ 0.00' ? 0.00 : c_gastos_produto);
      await formdata.append("gastosDeslocamento", c_gastos_deslocamento == 'R$ 0.00' ? 0.00 : c_gastos_deslocamento);
      await formdata.append("gastosAlimentacao", c_gastos_alimentacao == 'R$ 0.00' ? 0.00 : c_gastos_alimentacao);
      await formdata.append("gastosHospedagem", c_gastos_hospedagem == 'R$ 0.00' ? 0.00 : c_gastos_hospedagem);
      await formdata.append("gastosDiversos", c_gastos_outros == 'R$ 0.00' ? 0.00 : c_gastos_outros);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${URLBunge}/api/Requisicoes/FinalizarAtendimento`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)

          if(result.sucesso === true) {

            setTextoAguarde(false);
            AlertRedirect('Atendimento finalizado!', 'AcademiaFormularioListaTecnico', history);

          } else {

            setTextoAguarde(false);
            AlertForm(result.mensagem);

          }


        })
        .catch(error => console.log('error', error));







  };
  
  const [ ProdNome, setProdNome ] = useState("");
  const [ NFNome, setNFNome ] = useState("");

  const gastos_insumoInput = useRef();
  const [c_gastos_insumo, setc_gastos_insumo] = useState("R$ 0.00");
  const [v_gastos_insumo, setv_gastos_insumo] = useState(false);
  const [m_gastos_insumo, setm_gastos_insumo] = useState();

  const gastos_produtoInput = useRef();
  const [c_gastos_produto, setc_gastos_produto] = useState("R$ 0.00");
  const [v_gastos_produto, setv_gastos_produto] = useState(false);
  const [m_gastos_produto, setm_gastos_produto] = useState();

  const gastos_deslocamentoInput = useRef();
  const [c_gastos_deslocamento, setc_gastos_deslocamento] = useState("R$ 0.00");
  const [v_gastos_deslocamento, setv_gastos_deslocamento] = useState(false);
  const [m_gastos_deslocamento, setm_gastos_deslocamento] = useState();

  const gastos_alimentacaoInput = useRef();
  const [c_gastos_alimentacao, setc_gastos_alimentacao] = useState("R$ 0.00");
  const [v_gastos_alimentacao, setv_gastos_alimentacao] = useState(false);
  const [m_gastos_alimentacao, setm_gastos_alimentacao] = useState();

  const gastos_hospedagemInput = useRef();
  const [c_gastos_hospedagem, setc_gastos_hospedagem] = useState("R$ 0.00");
  const [v_gastos_hospedagem, setv_gastos_hospedagem] = useState(false);
  const [m_gastos_hospedagem, setm_gastos_hospedagem] = useState();

  const gastos_outrosInput = useRef();
  const [c_gastos_outros, setc_gastos_outros] = useState("R$ 0.00");
  const [v_gastos_outros, setv_gastos_outros] = useState(false);
  const [m_gastos_outros, setm_gastos_outros] = useState();


  const PegaNomeArquivo = async (data, e) => { 
    if(data.ProdfileUri.length > 0) {
      setProdNome(data.ProdfileUri[0]);
    }
    if(data.NFfileUri.length > 0) {
      setNFNome(data.NFfileUri[0]);
    }
  }
  
  function SomaValores() {
    var GastosInsumo = c_gastos_insumo == 'R$ 0.00' ? 0 : c_gastos_insumo;
    var GastosProduto = c_gastos_produto == 'R$ 0.00' ? 0 : c_gastos_produto;
    var GastosDeslocamento = c_gastos_deslocamento == 'R$ 0.00' ? 0 : c_gastos_deslocamento;
    var GastosAlimentacao = c_gastos_alimentacao == 'R$ 0.00' ? 0 : c_gastos_alimentacao;
    var GastosHospedagem = c_gastos_hospedagem == 'R$ 0.00' ? 0 : c_gastos_hospedagem;
    var GastosOutros = c_gastos_outros == 'R$ 0.00' ? 0 : c_gastos_outros;
    var SomaGastos
    = parseFloat(GastosInsumo)
    + parseFloat(GastosProduto)
    + parseFloat(GastosDeslocamento)
    + parseFloat(GastosAlimentacao)
    + parseFloat(GastosHospedagem)
    + parseFloat(GastosOutros);
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(SomaGastos)
  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
            
        <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Atendimento do Técnico</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/AcademiaFormularioListaTecnico', state: {} })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(EnviarFormulario)}>


                    <DescCampo>Check-in</DescCampo>
                    <EndLinha04>
                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_datain"
                                name="c_datain"
                                type="text"
                                placeholder={'Data'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="99/99/9999"
                            />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_horain"
                                name="c_horain"
                                type="text"
                                placeholder={'Hora'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask={"99:99"}
                            />
                        </CampoFormCadastro>
                    </EndLinha04>
                    

                    <br />
                    <DescCampo>Como foi o atendimento?</DescCampo>
                    <CampoFormCadastro>
                        <Controller
                            control={control}
                            ref={register}
                            id="c_comofoi"
                            name="c_comofoi"
                            type="text"
                            placeholder={'Pontos positivos e pontos negativos'}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                        />
                    </CampoFormCadastro>
                    <CampoFormCadastro>
                        <Controller
                            control={control}
                            ref={register}
                            id="c_qnt"
                            name="c_qnt"
                            type="number"
                            placeholder={'Quantas pessoas foram treinadas?'}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                        />
                    </CampoFormCadastro>


                    <br />
                    <CampoFormCadastro>

                      <DivFilePesquisa>
                        <div>Foto<div>{ProdNome.name}</div></div>
                        <Button variant="contained" component="label">
                          ANEXAR
                          <input ref={register} type="file" hidden name="ProdfileUri" id="ProdfileUri" accept="image/*" onChange={handleSubmit(PegaNomeArquivo)} />
                        </Button>
                      </DivFilePesquisa>

                      <DivFilePesquisa>
                        <div>Arquivo<div>{NFNome.name}</div></div>                          
                        <Button variant="contained" component="label">
                          ANEXAR
                          <input ref={register} type="file" hidden name="NFfileUri" id="NFfileUri" accept="image/*" onChange={handleSubmit(PegaNomeArquivo)} />
                        </Button>
                      </DivFilePesquisa>
                      
                    </CampoFormCadastro>
                    
                    <Clear />
                    <br />


                    <DescCampo>Houve bonificação?</DescCampo>
                    <CampoFormCadastro>
                        <select name={"c_bonificacao"} id={"c_bonificacao"} ref={register}>
                          <option value={0} disabled selected>Selecione</option>
                          <option value={true}>Sim</option>
                          <option value={false}>Não</option>
                        </select>
                    </CampoFormCadastro>


                    <br />
                    <DescCampo>Houve gastos com insumo?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_insumo"
                            name="c_gastos_insumo"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_insumo}
                            onChange={(_, valor) => setc_gastos_insumo(valor)}
                        />
                    </CampoFormCadastro>

                    <br />
                    <DescCampo>Houve gastos com produtos internos?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_produto"
                            name="c_gastos_produto"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_produto}
                            onChange={(_, valor) => setc_gastos_produto(valor)}
                        />
                    </CampoFormCadastro>

                    <br />
                    <DescCampo>Houve gastos com deslocamento (gasolina+pedágio)?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_deslocamento"
                            name="c_gastos_deslocamento"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_deslocamento}
                            onChange={(_, valor) => setc_gastos_deslocamento(valor)}
                        />
                    </CampoFormCadastro>

                    <br />
                    <DescCampo>Houve gastos com alimentação?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_alimentacao"
                            name="c_gastos_alimentacao"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_alimentacao}
                            onChange={(_, valor) => setc_gastos_alimentacao(valor)}
                        />
                    </CampoFormCadastro>

                    <br />
                    <DescCampo>Houve gastos com hospedagem?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_hospedagem"
                            name="c_gastos_hospedagem"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_hospedagem}
                            onChange={(_, valor) => setc_gastos_hospedagem(valor)}
                        />
                    </CampoFormCadastro>

                    <br />
                    <DescCampo>Outros gastos?</DescCampo>
                    <CampoFormCadastro>
                        <CurrencyInput
                            id="c_gastos_outros"
                            name="c_gastos_outros"
                            prefix="R$ "
                            decimalSeparator=","
                            thousandSeparator="."
                            maxlength="10"
                            value={c_gastos_outros}
                            onChange={(_, valor) => setc_gastos_outros(valor)}
                        />
                    </CampoFormCadastro>

                    <div>Valor total da visita: {SomaValores()}</div>

                    
                     
                    <br />
                    <DescCampo>Check-out</DescCampo>
                    <EndLinha04>
                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_dataout"
                                name="c_dataout"
                                type="text"
                                placeholder={'Data'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="99/99/9999"
                            />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_horaout"
                                name="c_horaout"
                                type="text"
                                placeholder={'Hora'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask={"99:99"}
                            />
                        </CampoFormCadastro>
                    </EndLinha04>






                        
                        <Clear />
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">FINALIZAR</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />


                        </FormPesquisa>



                    
                </div>  
            </ColunaRegras>
            


            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default AcademiaFormularioAtendimentoTecnico;
